import React, { createContext, useContext, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useToken } from '../hooks/useToken';

const ExamContext = createContext(null);

export function ExamContextProvider({ children }) {
  const { roomId } = useParams();
  const tokenData = useToken();
  const [activeWidget, setActiveWidget] = useState(null);

  const value = {
    roomId,
    activeWidget,
    setActiveWidget,
    ...tokenData,
  };
  return <ExamContext.Provider value={value}>{children}</ExamContext.Provider>;
}

export function useExamContext() {
  const ctx = useContext(ExamContext);
  return ctx;
}
